import { categoryUrl, fetchCategoryListUrl, reorderCategoryUrl, searchCategoryProductsUrl } from '../../utils/ConstantUtils'
import { getApiInstance } from '../axiosInterceptor'

const transformCategoryTree = (categories = []) => {
  return categories.map((category) => ({
    key: category._id,
    parentId: category.parentId,
    name: category.name,
    slug: category.slug,
    level: category.level,
    path: category.path,
    description: category.description,
    sortOrder: category.sortOrder,
    status: category.status,
    productCount: category.productCount || 0,
    thumbnailImage: category.thumbnailImage,
    bannerImage: category.bannerImage,
    children: transformCategoryTree(category.children || [])
  }))
}

export const fetchCategoryList = async (instance, params = {}) => {
  try {
    const response = await getApiInstance(instance).get(fetchCategoryListUrl, {
      params: { tree: true, ...params }
    })
    return transformCategoryTree(response.data?.categories || [])
  } catch (error) {
    console.error('Error fetching category list:', error)
    throw error
  }
}

export const fetchCategoryById = async (categoryId, instance) => {
  try {
    const response = await getApiInstance(instance).get(`${categoryUrl}/${categoryId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching category:', error)
    throw error
  }
}

export const createCategory = async (category, instance) => {
  try {
    const response = await getApiInstance(instance).post(`${categoryUrl}/create`, {
      name: category.name,
      slug: category.slug,
      parentId: category.parentId || null,
      description: category.description,
      thumbnailImage: category.thumbnailImage,
      bannerImage: category.bannerImage,
      sortOrder: category.sortOrder,
      status: category.status
    })
    return response.data
  } catch (error) {
    console.error('Error creating category:', error)
    throw error
  }
}

export const updateCategory = async (categoryId, category, instance) => {
  try {
    const response = await getApiInstance(instance).post(`${categoryUrl}/update`, {
      categoryId,
      name: category.name,
      slug: category.slug,
      description: category.description,
      thumbnailImage: category.thumbnailImage,
      bannerImage: category.bannerImage,
      sortOrder: category.sortOrder,
      status: category.status
    })
    return response.data
  } catch (error) {
    console.error('Error updating category:', error)
    throw error
  }
}

export const reorderCategories = async (items, instance) => {
  try {
    const response = await getApiInstance(instance).patch(reorderCategoryUrl, { items })
    return response.data
  } catch (error) {
    console.error('Error reordering categories:', error)
    throw error
  }
}

export const deleteCategory = async (categoryId, instance) => {
  try {
    const response = await getApiInstance(instance).delete(`${categoryUrl}/${categoryId}`)
    return response.data
  } catch (error) {
    console.error('Error deleting category:', error)
    throw error
  }
}

export const assignProductsToCategory = async (categoryId, keyCodes, instance) => {
  try {
    const response = await getApiInstance(instance).post(`${categoryUrl}/${categoryId}/products/assign`, {
      keyCodes
    })
    return response.data
  } catch (error) {
    console.error('Error assigning products to category:', error)
    throw error
  }
}

export const fetchCategoryProducts = async (categoryId, instance, { page = 1, limit = 20 } = {}) => {
  try {
    const response = await getApiInstance(instance).get(`${categoryUrl}/${categoryId}/products`, {
      params: { page, limit }
    })
    return {
      items: response.data?.data || [],
      pagination: response.data?.pagination || { page, limit, total: 0, totalPages: 0 }
    }
  } catch (error) {
    console.error('Error fetching category products:', error)
    throw error
  }
}

export const reorderCategoryProducts = async (categoryId, items, instance) => {
  try {
    const response = await getApiInstance(instance).patch(`${categoryUrl}/${categoryId}/products/reorder`, { items })
    return response.data
  } catch (error) {
    console.error('Error reordering category products:', error)
    throw error
  }
}

export const removeProductFromCategory = async (categoryId, keyCodes, instance) => {
  try {
    const response = await getApiInstance(instance).delete(`${categoryUrl}/${categoryId}/products`, {
      data: { keyCodes }
    })
    return response.data
  } catch (error) {
    console.error('Error removing product from category:', error)
    throw error
  }
}

export const searchCategoryProducts = async (keyword, instance, { page = 1, limit = 20 } = {}) => {
  try {
    const response = await getApiInstance(instance).get(searchCategoryProductsUrl, {
      params: { keyword, page, limit }
    })
    return {
      items: response.data?.data || [],
      pagination: response.data?.pagination || { page, limit, total: 0, totalPages: 0 }
    }
  } catch (error) {
    console.error('Error searching products:', error)
    throw error
  }
}

export const fetchCategoriesForProduct = async (keyCode, instance) => {
  try {
    const response = await getApiInstance(instance).get(`${categoryUrl}/products/${keyCode}/categories`)
    return response.data
  } catch (error) {
    console.error('Error fetching categories for product:', error)
    throw error
  }
}
